import { useI18n } from "@/i18n/I18nContext";
import { api, tokenStore } from "@/lib/api";

export const LangToggle = () => {
  const { lang, setLang } = useI18n();
  const choose = (l) => {
    setLang(l);
    if (tokenStore.get()) api.patch("/auth/me", { language: l }).catch(() => {});
  };
  return (
    <div className="flex h-10 items-center rounded-full border border-white/10 bg-white/5 p-1 text-xs font-semibold" data-testid="language-switcher">
      {["fr", "en"].map((l) => (
        <button
          key={l}
          onClick={() => choose(l)}
          data-testid={`language-toggle-${l}`}
          className={`h-8 min-w-[36px] rounded-full px-2 uppercase transition-colors duration-200 ${
            lang === l ? "bg-amber-500 text-[#0B0D12]" : "text-slate-400 hover:text-white"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
